module.exports = __webpack_public_path__ + "static/how-it-works-0dd7242a4bbe3a34cbf3c67381f62d9f.png";